import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  backgroundColor: colors.white,
  '& #content-title': {
    color: colors.black,
  },
  '& #content-description': {
    color: colors.black,
    ' li::marker': {
      color: colors.primary,
      fontSize: '1.2em',
      content: '""'
    },
    ' li': {
      paddingTop: '0.5rem',
    },
    ' svg': {
      color: colors.primary,
      verticalAlign: 'middle',
      marginRight: '0.5rem'
    }
  }
};

const contentStyles: any = (theme?: Theme) => styles;

export default contentStyles;